var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"print-table"},[_vm._m(0),_c('tbody',_vm._l((5),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(index + 1))]),_c('td')])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"24"}},[_vm._v("序号")]),_c('th',[_vm._v("备注要求如下")])])])
}]

export { render, staticRenderFns }